/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon20Regular = forwardRef('ArrowUiAuthLogoutIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1.999 5.251a3.25 3.25 0 0 1 3.25-3.25h5a.75.75 0 0 1 0 1.5h-5a1.75 1.75 0 0 0-1.75 1.75v9.5c0 .967.783 1.75 1.75 1.75h5a.75.75 0 0 1 0 1.5h-5a3.25 3.25 0 0 1-3.25-3.25v-9.5Z" }),
        React.createElement("path", { d: "m15.928 10.75-2.822 2.821a.75.75 0 0 0 1.061 1.06l3.273-3.272c.75-.75.75-1.967 0-2.718l-3.273-3.273a.75.75 0 1 0-1.06 1.06l2.82 2.822H6.75a.75.75 0 0 0 0 1.5h9.178Z" })));
});
